import { useState } from 'react';
import { useRouter } from 'next/router';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { FullWidthListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { PopupWithImage } from '@r1-frontend/ui-kit/molecules/Popup/WithImage';

import connectPopupAnalytics from '~/src/components/ConnectDomruPopup/analytics';
import { CLIENT_REFERRAL_LINK } from '~/src/components/ConnectDomruPopup/constants';
import { setView } from '~/src/components/ConnectDomruPopup/context/actions';
import { useContextDispatch } from '~/src/components/ConnectDomruPopup/context/hooks';

const RequestStopper = () => {
    const router = useRouter();

    const dispatch = useContextDispatch();

    const [isLoading, setIsLoading] = useState(false);

    const handleClose = () => {
        dispatch(setView('none'));
    };

    const onClickReferralButton = () => {
        if (location.pathname === CLIENT_REFERRAL_LINK) {
            handleClose();
        } else {
            setIsLoading(true);
            connectPopupAnalytics.applicationForm.moveStopper();
            router.push(CLIENT_REFERRAL_LINK).finally(() => setIsLoading(false));
        }
    };

    const showRequestForm = () => {
        connectPopupAnalytics.applicationFormHeader.moveStopper();
        dispatch(setView('callback'));
    };

    return (
        <PopupWithImage
            isOpen
            $width={600}
            onClose={handleClose}
            $image={{
                src: '/static/images/connect-domru/stopper-image.jpg',
                webpSrc: '/static/images/connect-domru/stopper-image.webp',
            }}
        >
            <FullWidthListContainer $direction={'column'} $desktop={24} $mobile={16}>
                <TextWrapper $lastIndent={false}>
                    <H3>Оформить заявку за&nbsp;несколько кликов</H3>
                    <Paragraph4>
                        Стоимость подключения при оформлении на&nbsp;сайте&nbsp;&mdash; 500&nbsp;₽, по&nbsp;телефону&nbsp;&mdash; 950&nbsp;₽.
                    </Paragraph4>
                </TextWrapper>

                <ButtonGroup>
                    <Button
                        bType={'action'}
                        loading={isLoading}
                        disabled={isLoading}
                        onClick={onClickReferralButton}
                    >
                        Выбрать тариф
                    </Button>
                    <Button
                        bType={'secondary'}
                        loading={isLoading}
                        disabled={isLoading}
                        onClick={showRequestForm}
                    >
                        Позвоните мне
                    </Button>
                </ButtonGroup>
            </FullWidthListContainer>
        </PopupWithImage>
    );
};

export default RequestStopper;
